import { ChangeDetectorRef, OnDestroy, OnInit, } from '@angular/core';
import { ActivatedRoute, Router, } from '@angular/router';
import { AppStateFacade, Setting, } from '@app-state';
import { ErrorCodes, UserType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { UiUserProfileGeneralComponent } from '@pages/profile/user-profile-general.component';
import { restrictedUrlTree } from '@pages/shared/restricted-access';
import { AuthService, ModalService, SignalRService, UserService, } from '@services';
import { DEFAULT_NOTIFICATION_SETTINGS } from '@services/user.service';
import { unsubscribe } from '@utils/object.utils';
import cloneDeep from 'lodash-es/cloneDeep';
import startCase from 'lodash-es/startCase';
import { BehaviorSubject, } from 'rxjs';
import { finalize, map, } from 'rxjs/operators';
var ProfilePageComponent = /** @class */ (function () {
    function ProfilePageComponent(userService, _appState, _cd, _modalService, _authService, _route, _router, _translateService, _signalRService) {
        var _this = this;
        this.userService = userService;
        this._appState = _appState;
        this._cd = _cd;
        this._modalService = _modalService;
        this._authService = _authService;
        this._route = _route;
        this._router = _router;
        this._translateService = _translateService;
        this._signalRService = _signalRService;
        this.isViewOnly = !!this._appState.settings.get(Setting.isCloudRPAInstanceEnabled);
        this.viewedUser = {};
        this.isHost = this._appState.user.loggedInAsHost;
        this.loading = {
            user$: new BehaviorSubject(false),
            password$: new BehaviorSubject(false),
            notifications: {},
        };
        this.notificationSettings = {};
        this.notificationSettingsPermissions = {};
        this.UserType = UserType;
        this.disallowEmailChange = false;
        this.disallowPasswordChange = false;
        this._currentUserNotificationPermissions = {};
        this._notificationPermissionUpdate = function (isGranted, key) {
            _this._currentUserNotificationPermissions[key] = isGranted;
            // trigger change detection if needed
            if (_this._currentUserNotificationPermissions === _this.notificationSettingsPermissions) {
                _this.notificationSettingsPermissions =
                    _this._currentUserNotificationPermissions =
                        cloneDeep(_this._currentUserNotificationPermissions);
            }
            _this._cd.markForCheck();
        };
        this._routeParamUpdate = function (params) {
            _this._general.viewMode(false);
            _this.userId = typeof params['id'] === 'undefined' ?
                _this._appState.user.value.id :
                parseInt(params['id'], 10);
            if (isNaN(_this.userId)) {
                _this._redirect();
            }
            if (!_this.isActiveUser) {
                if (_this._userSub) {
                    _this._userSub.unsubscribe();
                }
                _this.loading.user$.next(true);
                _this._userSub = _this.userService
                    .getInstance(_this.userId)
                    .pipe(finalize(function () { return _this.loading.user$.next(false); }))
                    .subscribe(function (user) {
                    if (user.type === UserType.Robot) {
                        _this._redirect();
                        return;
                    }
                    _this.notificationSettings = Object.assign(cloneDeep(DEFAULT_NOTIFICATION_SETTINGS), user.notificationSettings);
                    _this.notificationSettingsPermissions = DEFAULT_NOTIFICATION_SETTINGS;
                    _this.viewedUser = user;
                    _this._cd.markForCheck();
                }, function () {
                    _this._redirect();
                });
            }
            else {
                _this.viewedUser = cloneDeep(_this._appState.user.value);
                _this.notificationSettings = Object.assign(cloneDeep(DEFAULT_NOTIFICATION_SETTINGS), _this._appState.user.value.notificationSettings);
                _this.notificationSettingsPermissions = _this._currentUserNotificationPermissions;
                _this._cd.markForCheck();
            }
        };
        this.disallowEmailChange = !this._appState.authConfig.value.cloud.allowSelfEmailUpdate;
        this.disallowPasswordChange = !this._appState.authConfig.value.cloud.allowPasswordChange;
    }
    Object.defineProperty(ProfilePageComponent.prototype, "isEditable$", {
        get: function () {
            var _this = this;
            return this._appState.user.permissions
                .isGranted('Users.Edit')
                .pipe(map(function (result) {
                return result || _this.isActiveUser;
            }), map(function (result) { return result; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfilePageComponent.prototype, "isActiveUser", {
        get: function () {
            return this.userId === this._appState.user.value.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfilePageComponent.prototype, "isDirectoryEntity", {
        get: function () {
            return [UserType.DirectoryGroup, UserType.DirectoryUser].includes(this.viewedUser.type);
        },
        enumerable: true,
        configurable: true
    });
    ProfilePageComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this._appState.user.authState === 1 /* LoggedInAsTenant */) {
            Object.keys(DEFAULT_NOTIFICATION_SETTINGS).forEach(function (key) {
                _this["_" + key + "PermsSub"] =
                    _this._appState.user.permissions
                        .isGranted(startCase(key) + ".View")
                        .subscribe(function (isGranted) { return _this._notificationPermissionUpdate(isGranted, key); });
            });
        }
        this._routeParamSub = this._route
            .params
            .subscribe(this._routeParamUpdate);
    };
    ProfilePageComponent.prototype.ngOnDestroy = function () {
        unsubscribe(this._routeParamSub, this._userSub);
    };
    ProfilePageComponent.prototype.onEnterUserViewMode = function () {
        this.viewedUser = cloneDeep(this._appState.user.value);
    };
    ProfilePageComponent.prototype.onSubmitUser = function (user) {
        var _this = this;
        var payload = cloneDeep(user);
        var patchUser$;
        this.loading.user$.next(true);
        if (this.disallowEmailChange) {
            delete payload['emailAddress'];
        }
        if (this.isActiveUser) {
            patchUser$ = this._appState.user.patch(payload);
        }
        else {
            patchUser$ = this.userService.patch(this.viewedUser.id, payload);
        }
        patchUser$
            .pipe(finalize(function () { return _this.loading.user$.next(false); }))
            .subscribe(function () {
            _this._general.formGroup.reset(_this._general.formGroup.value);
            _this._general.viewMode(false);
        });
    };
    ProfilePageComponent.prototype.onSubmitPassword = function (password) {
        var _this = this;
        this._modalService.onConfirm(null, function () {
            _this.loading.password$.next(true);
            _this.userService
                .changePassword(_this._appState.user.value.id, {
                currentPassword: password.current,
                newPassword: password.new,
            })
                .pipe(finalize(function () { return _this.loading.password$.next(false); }))
                .subscribe(function () {
                _this._signalRService.disconnect();
                _this._authService.logout();
            }, function (response) {
                if (response.error &&
                    response.error.errorCode === ErrorCodes.UserIsLockedOut) {
                    _this._authService.logout();
                }
            });
        }, function () { }, this._translateService.instant('user_modal_password_warning'));
    };
    ProfilePageComponent.prototype.updateNotifications = function (notification) {
        var _this = this;
        var notificationSettings = this.notificationSettings;
        var update$;
        notificationSettings[notification.key] = notification.enabled;
        this.loading.notifications[notification.key] = true;
        if (this.isActiveUser) {
            update$ = this._appState.user.patch({ notificationSettings: notificationSettings });
        }
        else {
            update$ = this.userService.patch(this.userId, { notificationSettings: notificationSettings });
        }
        update$
            .pipe(finalize(function () {
            var state = {};
            state[notification.key] = false;
            _this.loading.notifications = Object.assign({}, _this.loading.notifications, state);
            _this._cd.markForCheck();
        }))
            .subscribe();
    };
    ProfilePageComponent.prototype._redirect = function () {
        this._router.navigateByUrl(restrictedUrlTree(this._router));
    };
    return ProfilePageComponent;
}());
export { ProfilePageComponent };
